function ArrowRight({ color }) {
    const style = { fill: color };

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 71.96 144" fill={color}>
            <title>arrow-right</title>
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                    <polygon className="cls-1" points="0 0 0 144 71.96 72 0 0"/>
                </g>
            </g>
        </svg>
    );
}

export default ArrowRight;
